module.exports = __webpack_public_path__ + "static/4-691140765aae8f6b6a3a80dd64f001cb.jpeg";